import React from "react";
import { styled } from "styled-components";
import { Button } from "antd";

const Card = ({ title, detailLink, joinLink, image }) => {
  return (
    <CardContainer>
      <ButtonSection>
        {detailLink && (
          <a href={detailLink}>
            <Button type="primary" ghost>
              <div>รายละเอียด</div>
            </Button>
          </a>
        )}
        {joinLink && (
          <a href={joinLink}>
            <Button type="primary">
              <div>เข้าร่วม</div>
            </Button>
          </a>
        )}
      </ButtonSection>
      <SectionAbove backgroundImage={image} />
      <SectionBelow>
        <Title>{title}</Title>
      </SectionBelow>
    </CardContainer>
  );
};

const CardContainer = styled.div`
  width: 300px;
  height: auto;
  padding-bottom: 40px;
  border-radius: 10px;
  background-color: white;
  overflow: hidden;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  position: relative;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SectionAbove = styled.div`
  background-image: ${(props) => `url(${props.backgroundImage})`};
  height: 200px;
  background-size: cover;
  transition: transform 0.3s ease-in-out;
  background-position: center;

  &:hover {
    transform: scale(1.05);
  }
`;

const SectionBelow = styled.div`
  padding: 10px;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  word-wrap: break-word;
`;

const ButtonSection = styled.div`
  display: flex;
  gap: 10px;
  position: absolute;
  bottom: 10px;
  right: 10px;
`;
export default Card;
